































import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { BModal } from 'bootstrap-vue';

import BaseTable from '../components/BaseTable.vue';
import BaseHeader from '../components/BaseHeader.vue';
import KeywiForm from '../components/KeywiForm.vue';

import { Column } from '../shared/types/column.class';
import { Filter } from '../shared/types/filter.class';

import Toast from '../shared/types/toast.class';
import { KeyWi } from '../api/keywis/keywi.model';
import { PaginateResult } from '@/shared/types/paginate-result.class';

const keywisModule = namespace('keywis');
const appModule = namespace('app');

// The @Component decorator indicates the class is a Vue component
@Component({ components: { BaseTable, BaseHeader, KeywiForm } })
export default class KeyWis extends Vue {
  $refs!: Vue['$refs'] & {
    detailModal: BModal;
    addKeyWiModal: BModal;
  };

  isLoading = false;

  tabIndex = 0;
  columns: Column[] = [
    new Column('name', 'Name'),
    new Column('deviceNumber', 'Device Number'),
  ];

  keywiForDetail: KeyWi = new KeyWi();
  newKeywi: KeyWi = new KeyWi();

  filter: Filter = new Filter();
  emailsForInvites: string[] = [];

  @keywisModule.Getter('all')
  keywis!: KeyWi[];

  @keywisModule.Getter('pagination')
  pagination!: PaginateResult<KeyWi>;

  @appModule.Mutation('addToast')
  addToast!: (toast: Toast) => void;

  @keywisModule.Action('fetchAll')
  fetchAll!: (filter?: Filter) => Promise<KeyWi[]>;

  @keywisModule.Action('delete')
  delete!: (id?: string) => Promise<void>;

  @keywisModule.Action('create')
  create!: (keywi: KeyWi) => Promise<KeyWi>;

  @keywisModule.Action('update')
  update!: (keywi: KeyWi) => Promise<KeyWi>;

  async doCreate(keywi: KeyWi) {
    await this.create(keywi);
    this.newKeywi = new KeyWi();
    this.doFetchAll();
  }

  onPageChanged(page: number) {
    this.filter.replaceFilter('page', page);
    this.doFetchAll();
  }

  async doUpdate(keywi: KeyWi) {
    await this.update(keywi);
    this.keywiForDetail = new KeyWi();
    this.doFetchAll();
  }
  async doFetchAll() {
    this.isLoading = true;
    await this.fetchAll(this.filter);
    this.isLoading = false;
  }

  doSearch(searchString: string) {
    this.filter.setSearch(searchString);
    this.doFetchAll();
  }

  doSort(field: string) {
    this.filter.setSort(field);
    this.doFetchAll();
  }

  openCreateModal() {
    this.$refs.addKeyWiModal.show();
  }

  openDetail(keywi: KeyWi) {
    this.$router.push({ name: 'KeywiDetail', params: { id: keywi._id } });
  }

  async doDelete(keywi: KeyWi) {
    const value = await this.$bvModal.msgBoxConfirm(
      `Are you sure you want to remove ${keywi.name}?`,
      {
        title: 'Confirm delete',
        okVariant: 'danger',
        okTitle: 'Yes',
        centered: true,
      },
    );
    if (value) {
      await this.delete(keywi._id);
      this.doFetchAll();
    }
  }

  clearEmails() {
    this.emailsForInvites = [];
  }

  created() {
    this.doFetchAll();
  }
}
